import { createStore, applyMiddleware } from 'redux'
import logger from 'redux-logger'
import { configureStore } from '@reduxjs/toolkit'

import Reducer from './reducer'
var store = createStore(Reducer as any, applyMiddleware(logger))

//const store = createStore(Reducer)
export default store
